import { BaseApi } from "./base-api.service";

export class RefreshAuthService extends BaseApi {
    constructor() {
        super();
        this.auth = false;
    }
    AcceptorAuth() {
        this.acceptor = true;
        return this.RefreshToken();
    }

    UserAuth() {
        this.acceptor = false;
        return this.RefreshToken();
    }
}